import { ROOT } from 'constants/paths';
import moment from 'moment';

//remove hash url paramater from the url
const removeHashUrl = () => {
  const originalTitle = document.title.includes('#')
    ? document.title.split('#')[0]
    : document.title;
  document.title = originalTitle;
  if (window.history.pushState) {
    //use replaceState to update current url including # sign.
    window.history.replaceState('', ROOT, window.location.pathname);
  } else {
    window.location.hash = '';
  }
};

const getRepaymentDate = (day, format = 'ymd') => {
  let today = new Date();
  let MM = today.getMonth() + 2;
  if (day < today.getDate()) {
    MM = MM + 1;
  }
  let yyyy = today.getFullYear();
  if (MM > 12) {
    yyyy += 1;
    MM = MM - 12;
  }

  day = parseInt(day);
  let dd = (day < 10 ? '0' : '') + day;
  let monthNames = [
    'January',
    'February',
    'March',
    'April',
    'May',
    'June',
    'July',
    'August',
    'September',
    'October',
    'November',
    'December'
  ];
  let MMstr = format === 'ymd' ? (MM < 10 ? '0' : '') + MM : monthNames[MM - 1];
  if (format === 'short') {
    const monthName = monthNames[MM - 1];
    MMstr = monthName.substring(0, 3);
  }
  let repaymentDate;
  if (format === 'ymd') {
    repaymentDate = `${yyyy}-${MMstr}-${dd}`;
  } else if (format === 'full' || format === 'short') {
    repaymentDate = `${day} ${MMstr} ${yyyy}`;
  } else {
    repaymentDate = `${dd} ${MMstr} ${yyyy}`;
  }
  return repaymentDate;
};

const padZero = (day) => {
  const parsedDay = parseInt(day);
  return parsedDay < 10 ? `0${parsedDay}` : `${parsedDay}`;
};
const getOrdinalNotation = (day) => {
  const parsedDay = `${day}`;
  const parsedDaystr =
    parsedDay === '1' || (!parsedDay.endsWith('11') && parsedDay.endsWith('1'))
      ? 'st'
      : parsedDay === '2' || (!parsedDay.endsWith('12') && parsedDay.endsWith('2'))
      ? 'nd'
      : parsedDay === '3' || (!parsedDay.endsWith('13') && parsedDay.endsWith('3'))
      ? 'rd'
      : 'th';

  return `${parsedDay}${parsedDaystr}`;
};

const getYearText = (term) => {
  return `${term} ${term > 1 ? 'years' : 'year'} `;
};

function debounce(fn, delay) {
  let timer = null;
  return function () {
    const context = this,
      args = arguments;
    clearTimeout(timer);
    timer = setTimeout(function () {
      fn.apply(context, args);
    }, delay);
  };
}

const todayday = new Date().getDate() + 1;
const repaymentDay =
  todayday > 28
    ? moment().add(2, 'month').startOf('month')
    : moment().add(1, 'day').add(1, 'month');

const validDateRegex = /^\d{4}-\d{2}-\d{2}$/;
/** a partial date looks like: YYYY-MM */
const partialDateRegex = /^\d{4}-\d{2}$/;
const singleMonthPartialDateRegex = /^\d{4}-\d{1}$/;

/**
 * Converts a shortended ISO date YYYY-MM to API required format.
 * @param {string} dateValue
 */
function formatShortenedIsoDate(dateValue) {
  if (dateValue) {
    if (validDateRegex.test(dateValue)) {
      return dateValue;
    }

    if (partialDateRegex.test(dateValue)) {
      return `${dateValue}-01`;
    }

    if (singleMonthPartialDateRegex.test(dateValue)) {
      // Leave this to be formatted correctly by moment instead.
      return dateValue;
    }
  }

  return dateValue;
}

export {
  debounce,
  getOrdinalNotation,
  getRepaymentDate,
  getYearText,
  padZero,
  removeHashUrl,
  repaymentDay,
  formatShortenedIsoDate
};
